import React from 'react'
import './styles.scss'
import sheetIco from './../../images/sheet-ico.svg';
import esignIco from './../../images/esign-ico.svg';
import cashIco from './../../images/cash-ico.svg';
import mobileIco from './../../images/mobile-ico.svg';
import orderIco from './../../images/order-ico.svg';
import flexIco from './../../images/flex-ico.svg';

const Benefits = () => {

    return (
        <section className="benefits">
            <div className="container">
                <div className="col">
                    <img src={ flexIco } alt="" />
                    <p>
                        Umowy dostosowane do potrzeb i przedmiotów
                    </p>
                </div>
                <div className="col">
                    <img src={ sheetIco } alt="" />
                    <p>
                        Gwarancja stałej raty przez cały okres umowy
                    </p>
                </div>
                <div className="col">
                    <img src={ esignIco } alt="" />
                    <p>
                        E-podpis umowy do <br /> 50 000 PLN
                    </p>
                </div>
                <div className="col">
                    <img src={ cashIco } alt="" />
                    <p>
                        Finansowanie 100% wartości przedmiotu
                    </p>
                </div>
                <div className="col">
                    <img src={ mobileIco } alt="" />
                    <p>
                        E-faktura, automatyczna płatność raty <br /> z konta
                    </p>
                </div>
                <div className="col">
                    <img src={ orderIco } alt="" />
                    <p>
                        Ubezpieczenie all risk dedykowane dla sprzętów
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Benefits;